import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Body from './pages/Body.js';
import About from './pages/About.js'
import BrowseBody from './pages/BrowseBody.js';
import Privacy from './pages/Privacy.js';
import ForYou from './pages/ForYou.js';
import YourBouquet from './pages/YourBouquet.js'
import PageNotFound from './pages/PageNotFound.js'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/build" element={ <Body/> } />
        <Route path="/browse" element={ <BrowseBody/> } />
        <Route path="/about" element={ <About/> } />
        <Route path="/privacy" element={ <Privacy/> } />
        <Route path="/foryou/:to/:from/:note/:sticker/:display/:ribbon/:flowers" action={({ params }) => {}} element={ <ForYou /> } />
        <Route path="/yourbouquet/:display/:ribbon/:flowers" action={({ params }) => {}} element={ <YourBouquet /> } />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();